import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../../Services/translation';
import { signUpForNewsletter } from '../../../Actions/Footer.action';

const NewsLetterSection = () => {

    const dispatch = useDispatch();

    const { newsLetterSignUpTitle,
        newsLetterSignUpText,
        newsLetterSignUpButtonText,
        signupDone, 
        newsLetterSignUpInformationText } = useSelector((state) => state.footer);

    const handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            submitForm();
        }
    }
    const error = translate('newsletter.complywithgdpr.warning');

    const submitForm = () => {
        if (checked === true) {
            dispatch(signUpForNewsletter(email));
        }
        else {
            setErrorMessage(error);
        }
    }

    const [email, setEmail] = useState();

    const [checked, setChecked] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = () => {
        setChecked(!checked);
    };

    return (
        <section className="newsletter-row">
            <div className="row">
                <h3 className="newsletter-row__title footer__title">{newsLetterSignUpTitle}</h3>
                <p className="newsletter-row__text">{newsLetterSignUpText}</p>
                {!signupDone ? <div className="newsletter-row__input-wrapper">
                    <input className="form__input" onKeyDown={handleKeyDown} placeholder={translate('newsletter.email')} onChange={(event) => setEmail(event.target.value)} />
                    <button className="button" onClick={() => submitForm()}>
                        {newsLetterSignUpButtonText}
                    </button>
                    <div className="newsletter-row__comply-with-gdpr">
                        {errorMessage && (
                            <p className="newsletter-row__comply-with-gdpr__error">{errorMessage}</p>
                        )}
                        <input
                            className="newsletter-row__comply-with-gdpr__input"
                            type="checkbox"
                            id="complywithgdpr"
                            checked={checked}
                            onChange={handleChange}
                        />
                        <label
                            className="newsletter-row__comply-with-gdpr__label"
                            htmlFor="complywithgdpr"
                            dangerouslySetInnerHTML={{ __html: newsLetterSignUpInformationText.value }}
                        >  
                        </label>
                    </div>
                </div>
                    :
                    <div>
                        <p className="newsletter-row__confirmation">{translate('newsletter.signup.confirmation')}</p>
                    </div>

                }
            </div>

        </section>
    )
};
export default NewsLetterSection;